<script setup>
import JetBanner from '@/Jetstream/Banner.vue';
import AppHead from '@/Components/AppHead.vue';
import NavBar from '@/Components/NavBar.vue'
import Footer from '@/Components/Footer.vue'
import { ref } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import Modal from '@/Components/Modal';
import { usePage } from '@inertiajs/inertia-vue3';

defineProps({
    title: '',
    desc: '',
    image: ''
});

</script>

<script>
export default {
    data(){
        return{
        animate: false,
        };
    },
    mounted(){
        this.animate = true;

        setTimeout(() => {
            document.getElementById('loader-bg').style.display = 'none';
            document.getElementById('loader').style.display = 'none';
        }, 1000);

        if (window.location.href.indexOf("#") == -1){
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 800);
        }

    },
    methods: {
        backToTop: () => {
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 200);
        }
    }
};
</script>

<template>
    <div>
        <div id="loader-bg"></div>
        <div id="loader">
            <div class="loadingio-spinner-eclipse-xhkj9j9tmp"><div class="ldio-s0eig2i8m3">
            <div></div>
            </div></div>
        </div>
        <AppHead :title="title ? title : 'Welcome To Inspire Properties'" :desc="desc ? desc : 'Discovers a wide range of properties in Dubai and UAE with Inspire Properties'" :image="image ? image : asset('/images/inspire-logo-share.jpg')" />

        <!-- <JetBanner /> -->

        <div class="wrapper min-h-screen">
            <NavBar />

            <!-- Page Heading -->
            <div v-if="$slots.header">
                <section class="page-header">
                    <div class="page-header-wrapper">
                        <div class="container">
                            <slot name="header" />
                        </div>
                    </div>
                </section>
            </div>

            <!-- Page Content -->
            <main>
                <transition name="fade" mode="out-in" appear>
                    <div :key="$page.url">
                        <slot />
                    </div>
                </transition>
            </main>

            <Footer />

            <Modal></Modal>

            <div id="back-to-top" class="d-none">
                <button @click="backToTop()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
@keyframes ldio-s0eig2i8m3 {
  0% { transform: rotate(0deg) }
  50% { transform: rotate(180deg) }
  100% { transform: rotate(360deg) }
}
.ldio-s0eig2i8m3 div {
  position: absolute;
  animation: ldio-s0eig2i8m3 0.83s linear infinite;
  width: 72px;
  height: 72px;
  top: 14px;
  left: 14px;
  border-radius: 50%;
  box-shadow: 0 2.9px 0 0 #e09a3d;
  transform-origin: 36px 37.45px;
}
.loadingio-spinner-eclipse-xhkj9j9tmp {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  position: fixed;
  top: 45%;
  left: 40%;
  z-index: 10000;
}

@media screen and (min-width: 475px) {
    .loadingio-spinner-eclipse-xhkj9j9tmp {
        left: 45%;
    }
}

#loader-bg{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 9999;
}
.ldio-s0eig2i8m3 {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-s0eig2i8m3 div { box-sizing: content-box; }
</style>
